(function($) {
  Drupal.behaviors.custom = {
    attach: function(context, settings) {
      var node_course = $('.node-course');
      if (node_course.length !== 0) {
        $('.form-item-format select').chosen();
        // Get the Chosen select element
        var $select = $('.form-item-format select');

        // Set the new placeholder text
        $select.attr('data-placeholder', '- Any -');

        // Refresh the Chosen select to apply the changes
        $select.trigger('chosen:updated');
      }
    }
  };
})(jQuery);
